<template>
    <b-card class="mb-1">
    <div class="leftAlign">

    <div v-if="responsesList.length > 1">
      <b-form-group label-for="phoneticTranscriptionConsult" description="Dérouler la liste pour choisir la transcription à supprimer">
        <b-form-select id="phoneticTranscriptionConsult" :options="responsesList"  value-field="rousselotPhoneticForm"
        text-field="rousselotPhoneticForm"
        size="lg" v-model="phoneticTranscription"></b-form-select>
      </b-form-group>
    </div>

      <b-card-text v-if="phoneticTranscription != null">
        <p class="formGroupTitle">Points d'enquête concernés par la suppression</p>
        <b-card bg-variant="light">
            <b-card-text id="selectedinvEntries" class="overflow-auto">
            <span v-for="(d3Circle, index) in circleList" :key="d3Circle.id">
                {{ d3Circle.id  + ''}}
                {{ index < circleList.length -1 ? ', ' : ''}}
              </span>
            </b-card-text>
        </b-card>
        <b-form-text>
          (Maj + Clic) sur un point de la carte pour l'ajouter à ou le retirer de cette liste.
            Entre parenthèses la ou les formes phonétiques du PE si il en a déjà. 
        </b-form-text>
      </b-card-text>
      </div>
      <br>
      <b-button id="phoneticTranscriptionButton" variant="success" @click="deletePhoneticTranscription()">Supprimer</b-button>
    </b-card>
</template>

<script>
import { mapGetters } from 'vuex'
import EventBus from '@components/bus/bus.js';

export default {
  name: 'PhoneticTranscriptionsSuppression',
  props: ['responsesList'],
  computed: {
    ...mapGetters({
      circleList: 'getCircleList',
      invEntrySameRousselotPhoneticFormList: 'getInvEntrySameRousselotPhoneticFormList'
    })
  },
  data() {
    return {
      phoneticTranscription: null,
      complementaryInformation: null
    };
  },
  created(){  
  this.phoneticTranscription = this.responsesList[0].rousselotPhoneticForm 
  this.complementaryInformation = this.responsesList[0].complementaryInformation
  },
  watch: {
    responsesList() {
      this.phoneticTranscription = this.responsesList[0].rousselotPhoneticForm
      this.complementaryInformation = this.responsesList[0].complementaryInformation
    },
    phoneticTranscription() { 
      this.$store.dispatch('reloadData', { invEntrySameRousselotPhoneticFormList: this.invEntrySameRousselotPhoneticFormList, phoneticTranscription: this.phoneticTranscription})
    }
  },
  methods: {
    deletePhoneticTranscription: function() {
      this.$store.dispatch('deletePhoneticTranscription', { 
        phoneticTranscriptionToDelete: this.phoneticTranscription, complementaryInfoToDelete: this.complementaryInformation })
      EventBus.$emit('closeSideBar');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/commons/sideBarViewer/phoneticTranscriptionsSideBar/PhoneticTranscriptionsSuppression.vue